import { observer } from "mobx-react";
import React, { useContext } from "react";
import { Textarea, Button, Group, Paper, Stack } from "@mantine/core";
import { IconSearch, IconTrash } from "@tabler/icons-react";
import { CheckBitcoinAddressStoreContext } from "../stores/CheckBitcoinAddressStore";

const AddressInput: React.FC = observer(() => {
  const store = useContext(CheckBitcoinAddressStoreContext);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
      store.checkAddress();
    }
  };

  return (
    <Paper
      p="md"
      radius="md"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      <Stack gap="sm">
        <Textarea
          placeholder="Paste any address here — Bitcoin, Lightning Address, BOLT11 invoice, or anything else..."
          value={store.addressInput}
          onChange={(e) => store.setAddressInput(e.currentTarget.value)}
          onKeyDown={handleKeyDown}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          autoComplete="off"
          minRows={3}
          maxRows={6}
          autosize
          styles={{
            input: {
              fontFamily: "monospace",
              fontSize: "13px",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              border: "1px solid rgba(255, 255, 255, 0.15)",
              color: "white",
            },
          }}
        />
        <Group justify="flex-end">
          <Button
            variant="subtle"
            color="gray"
            leftSection={<IconTrash size={16} />}
            onClick={() => store.clear()}
            disabled={!store.addressInput}
          >
            Clear
          </Button>
          <Button
            leftSection={<IconSearch size={16} />}
            onClick={() => store.checkAddress()}
            disabled={!store.addressInput.trim()}
            loading={store.isCheckingLightning}
          >
            Check Address
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
});

export default AddressInput;
